var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"video-preview-wapper",attrs:{"element-loading-text":_vm.$t('lang.k_300001')}},[(_vm.videoParam)?_c('video-preview',{ref:"videoPreview",attrs:{"videoParam":_vm.videoParam}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }